import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { FullPageLoader } from '@/shared/components/full-page-loader';
import { usePermissionPassbook } from '../api/use-permissions';

/** Seção antiga de Permissões → aba do hub do cliente. */
const SECTION_TO_TAB: Record<string, string> = {
  programa: 'recursos',
  paginas: 'paginas',
  ia: 'ia',
  lojas: 'ia',
  usuarios: 'usuarios',
};

/**
 * `/loja/:id/permissoes/:section` e `/loja/:id/configurar` → `/clientes/:clientId?tab=`.
 * O passbook sabe o cliente dele (`clientId`); a URL antiga continua valendo.
 */
export function PassbookToClientHubRedirect() {
  const { idPassbook = '', section } = useParams<{ idPassbook: string; section?: string }>();
  const [params] = useSearchParams();
  const { data, isLoading, isError } = usePermissionPassbook(idPassbook || null);

  if (!idPassbook) return <Navigate to="/clientes" replace />;
  if (isLoading) return <FullPageLoader />;
  if (isError || !data?.clientId) return <Navigate to="/clientes" replace />;

  const tab = (section && SECTION_TO_TAB[section]) ?? params.get('tab') ?? 'recursos';
  return <Navigate to={`/clientes/${data.clientId}?tab=${tab}`} replace />;
}
